import { render, staticRenderFns } from "./CreditWorkSimulator.vue?vue&type=template&id=016a7145&"
import script from "./CreditWorkSimulator.vue?vue&type=script&lang=js&"
export * from "./CreditWorkSimulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports